
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { environment } from '../../../../environments/environment';
 import { permissionRoles} from '../../../providers/static-data';
@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private apiUrl = environment?.apiUrl;
 
 
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toasterService: ToasterService,
  ) {}
  permissionRoles = permissionRoles;
  getHeader(): Observable<HttpHeaders> {
    const token = localStorage.getItem('token'); // or from service
 
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
 
    return of(headers); 
  }
 
  getMenus(): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}uac/main-menu/get-assignable`, {
          headers,
          observe: 'response',
        }).pipe(
          tap((response) => console.log('🚀 API response received', response.body)),
        );
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.error('Unauthorized access:', error);
          this.handleTokenExpired();
        }
        return throwError(() => error);
      }),
    );
  }

  getRoleMenuPermissionsByRoleId(roleId: string): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.get(`${this.apiUrl}uac/role-permissions/${roleId}`, {
          headers,
          observe: 'response',
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.error('Unauthorized access:', error);
          this.handleTokenExpired();
        }
        return throwError(() => error);
      }),
    );
  }

  getRoleMenuPermissionJson(): Observable<any> {
    const roleIds: string[] = (this.permissionRoles ?? []).map((r: any) => String(r?.value)).filter(Boolean);

    return forkJoin(roleIds.map((roleId) => this.getRoleMenuPermissionsByRoleId(roleId))).pipe(
      switchMap((responses: any[]) => {
        const roles: Record<
          string,
          {
            mainMenuIds: number[];
            enabledActionIds: Record<string, true>;
          }
        > = {};

        responses.forEach((res, idx) => {
          const roleId = roleIds[idx];
          const body = res?.body ?? res;
          const data = body?.data ?? body;

          const mainMenuIds: number[] = Array.isArray(data?.main_menu_ids) ? data.main_menu_ids : [];
          const masterUacActionIds: number[] = Array.isArray(data?.master_uac_action_ids)
            ? data.master_uac_action_ids
            : [];

          const enabledActionIds: Record<string, true> = {};
          masterUacActionIds.forEach((actionId) => {
            enabledActionIds[String(actionId)] = true;
          });

          roles[String(roleId)] = { mainMenuIds, enabledActionIds };
        });

        return of({ roles });
      }),
      catchError(() => of({ roles: {} })),
    );
  }


  saveRoleMenuPermissionJson(json: any): Observable<void> {
    return of(void 0);
  }

  createRoleBasedMainMenus(payload: {
    main_menu_ids: number[];
    role_id: string;
    is_active: boolean;
  }): Observable<any> {
    const masterUserIdRaw = localStorage.getItem('auth_data') ? JSON.parse(localStorage.getItem('auth_data')!).user?.id : null;
    const UserId = masterUserIdRaw != null ? Number(masterUserIdRaw) : null;

    const body = {
      ...payload,
      id: UserId,
    };

    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.post(`${this.apiUrl}uac/role-based-main-menus/get-by-id`, body, {
          headers,
          observe: 'response',
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.error('Unauthorized access:', error);
          this.handleTokenExpired();
        }
        return throwError(() => error);
      }),
    );
  }

 
  getMenuActions(menuId: number): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        console.log("menuId :",menuId)
        return this.http.get(
          `${this.apiUrl}master/uac-actions/${menuId}/show`,
          {
            headers: headers,
            observe: 'response',
          },
        );
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.error('Unauthorized access:', error);
          this.handleTokenExpired();
        }
        return throwError(() => error);
      }),
    );
  }
 
  createMenu(data: any): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.post(`${this.apiUrl}uac/role-permissions/save`, data, {
          headers: headers,
          observe: 'response',
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.error('Unauthorized access:', error);
          this.handleTokenExpired();
        }
        return throwError(() => error);
      }),
    );
  }
 
  updateMenu(id: number, data: any): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.put(`${this.apiUrl}master/menus/${id}`, data, {
          headers: headers,
          observe: 'response',
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.error('Unauthorized access:', error);
          this.handleTokenExpired();
        }
        return throwError(() => error);
      }),
    );
  }
 
  deleteMenu(id: number): Observable<any> {
    return this.authService.getHeader().pipe(
      switchMap((headers: HttpHeaders) => {
        return this.http.delete(`${this.apiUrl}master/menus/${id}`, {
          headers: headers,
          observe: 'response',
        });
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.error('Unauthorized access:', error);
          this.handleTokenExpired();
        }
        return throwError(() => error);
      }),
    );
  }
 
  private handleTokenExpired() {
    this.toasterService.setToaster(
      'default',
      'Session Expired',
      'The session has expired. Please log in again.',
    );
    this.authService.logout();
  }
}